// src/contexts/AuthContext.js
import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL, APP_BASE_URL } from "../config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [action, setAction] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState(null);
  const [encryptedData, setencryptedData] = useState(null);

  const validateEncryptedData = async (encryptedData, actionDo) => {
    try {
      setIsLoading(true);
      setencryptedData(encryptedData)
      const response = await axios.post(`${API_BASE_URL}/x1bf/x1wh/auth-checker`, {
        data: encryptedData,
      });

      const { status, message, data } = response.data;

      if (status === "success") {
        setAction(actionDo);
        setData(data);
        handleAction(actionDo);
      } else {
        showUnauthorizedAlert(message || "For security reasons, your session has expired. Please log in again and use the One Time Password (OTP) to continue in the Amaphil chat on Messenger: https://www.facebook.com/Amaphil.Inc/");
      }
    } catch (error) {
      console.error("Error validating encrypted data:", error);
      // showUnauthorizedAlert("Something went wrong during authentication.");
      showUnauthorizedAlert("For security reasons, your session has expired. Please log in again and use the One Time Password (OTP) to continue in the Amaphil chat on Messenger: https://www.facebook.com/Amaphil.Inc/");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAction = (actionDo) => {
    switch (actionDo) {
      case "generate-approval":
        setIsModalOpen(true);
        break;
      case "mobile-update":
        setIsModalOpen(true);
        break;
      case "email-update":
        setIsModalOpen(true);
        break;
      case "generate-mobile-app-creds":
        setIsModalOpen(true);
        break;
      case "loa-transaction-history":
        setIsModalOpen(true);
        break;
      case "plan-and-benefits":
        setIsModalOpen(true);
        break;
      case "feedback":
        setIsModalOpen(true);
        break;
      default:
        showUnauthorizedAlert("Unsupported action.");
        break;
    }
  };

  const showUnauthorizedAlert = (message = "For security reasons, your session has expired. Please log in again and use the One Time Password (OTP) to continue in the Amaphil chat on Messenger: https://www.facebook.com/Amaphil.Inc/") => {
    Swal.fire({
      title: "Unauthorized Access",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    }).then(() => {
      // window.location.href = APP_BASE_URL;
      console.log(APP_BASE_URL)
    });
  };

  return (
    <AuthContext.Provider
      value={{
        isLoading,
        setIsLoading,
        action,
        isModalOpen,
        data,
        validateEncryptedData,
        setIsModalOpen,
        encryptedData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
